/**
 * Skeleton placeholder mimicking the Scorecard layout so users see the
 * page shape (ribbon → pies → timeseries) immediately instead of a blank
 * "Cargando…" text. Reduces perceived load time from ~7s to instant.
 */
export default function ScorecardSkeleton() {
  const shimmer = {
    background: "linear-gradient(90deg, #eef2f7 25%, #f7f9fc 50%, #eef2f7 75%)",
    backgroundSize: "200% 100%",
    animation: "sk-shimmer 1.4s linear infinite",
    borderRadius: 8,
  };
  return (
    <div data-testid="scorecard-skeleton">
      <style>{`@keyframes sk-shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}`}</style>
      {/* Overview ribbon (6 KPI cards) */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="p-4 bg-white" style={{ ...shimmer, height: 92 }} />
        ))}
      </div>
      {/* Row 1 — three pies side-by-side */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-6">
        {[0, 1, 2].map((i) => (
          <div key={i} className="p-5 bg-white" style={{ ...shimmer, height: 320 }} />
        ))}
      </div>
      {/* Row 2 — timeseries */}
      <div className="mb-6">
        <div style={{ ...shimmer, height: 380 }} className="p-5 bg-white" />
      </div>
    </div>
  );
}
